export default function getTokenId(): string {
  const tokenId = new URLSearchParams(window.location.search).get("tokenId");

  if (tokenId) return tokenId;

  return process.env.NODE_ENV === "production"
    ? ""
    : process.env.REACT_APP_TEST_TOKEN_ID || "";
}
